"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStackTrace = exports.formatValidationError = exports.formatError = void 0;
const nested_error_stacks_1 = __importDefault(require("nested-error-stacks"));
function formatError(...errors) {
    const result = [];
    for (const error of errors) {
        result.push({ msg: error });
    }
    return { errors: result };
}
exports.formatError = formatError;
function formatValidationError(error) {
    const msg = error.details.map(({ message }) => message);
    return formatError(...msg);
}
exports.formatValidationError = formatValidationError;
function getStackTrace(error) {
    return new nested_error_stacks_1.default(undefined, error).stack || '';
}
exports.getStackTrace = getStackTrace;
